import { Injectable } from '@angular/core';
import { ZdarzeniaFiltrModel } from '../models/zdarzenia-filtr.model';
import { DataFilterServiceBase } from './data-filter-base.service';
import { DateHelper } from '../helpers/dateHelper';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataFilterZdarzeniaService extends DataFilterServiceBase<ZdarzeniaFiltrModel> {

  loadingWczesniejszeZdarzenia$ = new BehaviorSubject<boolean>(false);

  constructor(
  ) {
    super();
  }
}
